var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIcon = function SvgAIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 29 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#22253B",
    d: "M22.5 12a1.48 1.48 0 0 1-.984 1.406l-5.948 2.163-2.162 5.947a1.5 1.5 0 0 1-2.812 0l-2.162-5.948-5.948-2.162a1.5 1.5 0 0 1 0-2.812l5.948-2.162 2.162-5.948a1.5 1.5 0 0 1 2.812 0l2.163 5.948 5.947 2.162A1.48 1.48 0 0 1 22.5 12"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#AIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#22253B",
    d: "M28.375 6a.62.62 0 0 1-.41.586l-2.479.9-.9 2.479a.626.626 0 0 1-1.172 0l-.9-2.478-2.479-.901a.625.625 0 0 1 0-1.172l2.478-.9.9-2.48a.625.625 0 0 1 1.173.001l.9 2.478 2.479.9a.62.62 0 0 1 .41.587"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "AIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 1h10v10H19z"
  })))));
};
export default SvgAIcon;